import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { DashboardSidebar } from "@/components/DashboardSidebar";
import { Mail, Phone, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const Support = () => {
  const contactOptions = [
    {
      icon: <Mail className="w-6 h-6" />,
      label: "Email Support",
      action: "mailto:support@example.com",
      description: "Get help via email"
    },
    {
      icon: <Phone className="w-6 h-6" />,
      label: "Phone Support",
      action: "tel:+1234567890",
      description: "Speak with our team"
    },
    {
      icon: <MessageCircle className="w-6 h-6" />,
      label: "WhatsApp",
      action: "https://wa.me/1234567890",
      description: "Chat with us on WhatsApp"
    }
  ];

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-[#1A1F2C]">
        <div className="bg-[#1A1F2C]">
          <DashboardSidebar />
        </div>
        <div className="flex-1 bg-[#1A1F2C] bg-gradient-to-br from-[#1A1F2C] via-[#221F26] to-[#1A1F2C] overflow-auto">
          <div className="absolute inset-0 bg-[url('/grid.svg')] bg-center [mask-image:linear-gradient(180deg,white,rgba(255,255,255,0))] opacity-20" />
          
          <main className="relative z-10 flex-1 px-4 py-8">
            <div className="container mx-auto">
              <div className="flex justify-between items-center mb-8">
                <h1 className="text-3xl font-bold text-white">Support</h1>
                <SidebarTrigger />
              </div>
              
              <div className="glass-card p-6 rounded-xl shadow-lg bg-white/5 backdrop-blur-sm border border-white/10">
                <h2 className="text-xl font-semibold text-white mb-6">Contact support for assistance</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  {contactOptions.map((option, index) => (
                    <a
                      key={index}
                      href={option.action}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block"
                    >
                      <Button
                        variant="outline"
                        className="w-full h-auto p-6 flex flex-col items-center gap-4 bg-white/5 hover:bg-white/10 border-white/10 text-white transition-all duration-300"
                      >
                        {option.icon}
                        <div className="text-center">
                          <h3 className="font-semibold mb-2">{option.label}</h3>
                          <p className="text-sm text-gray-400">{option.description}</p>
                        </div>
                      </Button>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default Support;